import React, { useState, useContext, useEffect } from "react";
import { Formik } from "formik";
import { Table, Empty, Button, Select } from "antd";

import * as Yup from "yup";
import ErrorMessage from "../components/ErrorMessage";

import authClient from "../api/authClient";
import AuthContext from "../auth/context";

import "antd/dist/antd.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Option } = Select;

const columns = [
  {
    title: "Nom",
    dataIndex: "nomClient",
    key: "nomClient",
    sorter: (a, b) => a.nomClient.localeCompare(b.nomClient),
  },
  {
    title: "Prénom",
    dataIndex: "prenomClient",
    key: "prenomClient",
    sorter: (a, b) => {
      let strA = a.prenomClient ? a.prenomClient : "";
      let strB = b.prenomClient ? b.prenomClient : "";
      return strA.localeCompare(strB);
    },
  },
  {
    title: "Libellé",
    dataIndex: "libelle",
    key: "libelle",
    sorter: (a, b) => {
      let strA = a.libelle ? a.libelle : "";
      let strB = b.libelle ? b.libelle : "";
      return strA.localeCompare(strB);
    },
  },
  {
    title: "Code NFC",
    dataIndex: "codeNfc",
    key: "codeNfc",
    sorter: (a, b) => {
      let strA = a.codeNfc ? a.codeNfc : "";
      let strB = b.codeNfc ? b.codeNfc : "";
      return strA.localeCompare(strB);
    },
  },
  {
    title: "Identifiant d'origine",
    dataIndex: "idOrigine",
    key: "idOrigine",
  },
  {
    title: "Téléphone",
    dataIndex: "telephone",
    key: "telephone",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
    key: "mobile",
  },
];

const validationSchema = Yup.object().shape({
  societe: Yup.string().required("La société est obligatoire"),
});

const Clients = () => {
  const [loading, setLoading] = useState(false);
  const [initDone, setInitDone] = useState(false);
  const [listeSocietes, setListeSocietes] = useState([]);
  const [listeClients, setListeClients] = useState([]);

  const authContext = useContext(AuthContext);

  useEffect(() => {
    initListes();
  }, []);

  const initListes = async () => {
    setLoading(true);

    const retour = await authClient.getSocietes();

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        setListeSocietes(retour.data);
      } else {
        setListeSocietes(undefined);
      }

      setInitDone(true);
    }
  };

  const lancerRecherche = async (values) => {
    setLoading(true);
    const retour = await authClient.getClients(values);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        console.log(retour.data);
        setListeClients(retour.data);
      } else {
        setListeClients(undefined);
      }
    }
  };

  const zoneDetailClient = (record) => (
    <>
      <div className="row mb-2">
        <div className="col">
          <div className="row">
            <div className="col">
              <b>
                {record.nomClient} {record.prenomClient}
              </b>
            </div>
          </div>
          <div className="row">
            <div className="col">Libellé : {record.libelle}</div>
          </div>
          <div className="row">
            <div className="col">Code NFC : {record.codeNfc}</div>
          </div>
          {record.acces && (
            <div className="row">
              <div className="col">Accès : {record.acces}</div>
            </div>
          )}
          <div className="row">
            <div className="col">
              <i className="uil-map-marker mr-1"></i>
              {record.numeroEtVoie}
            </div>
          </div>
          {record.adresseSuite && (
            <div className="row">
              <div className="col">{record.adresseSuite}</div>
            </div>
          )}

          <div className="row">
            <div className="col">
              {record.codePostal} {record.ville}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-envelope mr-1"></i>
              <a href={"mailto:" + record.email}>{record.email}</a>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-phone mr-1"></i>
              Téléphone : {record.telephone}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <i className="uil-phone mr-1"></i>
              Mobile : {record.mobile}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  if (!initDone)
    return (
      <>
        <ToastContainer />
      </>
    );

  return (
    <>
      <ToastContainer />
      <div
        className="modal fade"
        id="userModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Détails du client
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group mb-1">
                <label htmlFor="loginUser">Identifiant</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="nomUser">Nom</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="prenomUser">Prénom</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="emailUser">Email</label>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                loading={loading}
                className="btn btn-secondary"
                type="primary"
                data-dismiss="modal"
              >
                Fermer
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <h4 className="page-title">Clients</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Critères de recherche</div>
            <div className="card-body">
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  societe: "",
                  nom: "",
                  prenom: "",
                  imei: "",
                }}
                onSubmit={(values) => {
                  lancerRecherche(values);
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  setFieldTouched,
                  touched,
                  setFieldValue,
                  setErrors,
                  values,
                }) => (
                  <>
                    <div className="form-row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="societe">Société :</label>
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            id="societe"
                            value={values["societe"]}
                            onChange={handleChange("societe")}
                            className="form-control"
                          >
                            <Option value="">
                              Veuillez sélectionner une société
                            </Option>
                            {listeSocietes.map((s) => (
                              <Option
                                key={s.idSociete}
                                value={s.idSociete.toString()}
                              >
                                {s.nomSociete}
                              </Option>
                            ))}
                          </Select>
                          <ErrorMessage
                            error={errors.societe}
                            visible={touched.societe}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="nom">Nom :</label>
                          <input
                            value={values["nom"]}
                            onChange={handleChange("nom")}
                            className="form-control"
                            id="nom"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="prenom">Prénom :</label>
                          <input
                            value={values["prenom"]}
                            onChange={handleChange("prenom")}
                            className="form-control "
                            id="prenom"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group d-flex align-items-center justify-content-end mt-2 mb-0 ">
                      <Button
                        loading={loading}
                        className="btn btn-primary"
                        type="primary"
                        onClick={handleSubmit}
                      >
                        Rechercher
                      </Button>
                    </div>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Liste des Clients</div>
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  rowKey="id"
                  loading={loading}
                  columns={columns}
                  dataSource={listeClients}
                  expandable={{
                    expandedRowRender: (record) => zoneDetailClient(record),
                  }}
                  locale={{
                    sortTitle: "trier",
                    cancelSort: "Cliquez pour annuler le tri",
                    triggerAsc: "Cliquez pour un tri ascendant",
                    triggerDesc: "Cliquez pour un tri descendant",
                    emptyText: (
                      <Empty
                        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                        imageStyle={{
                          height: 60,
                        }}
                        description={<span>Aucun Client</span>}
                      ></Empty>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
